import { GET_MY } from '../../containers/App/constants';
import { REQUEST_EMAIL_HISTORY, REQUEST_EMAIL_HISTORY_FILTER, FILTER_DEFAULT_LIMIT } from './constants';

export function fetchHistory(offset = 0, limit = FILTER_DEFAULT_LIMIT, callback) {
  return {
    type: GET_MY,
    id: REQUEST_EMAIL_HISTORY,
    work: REQUEST_EMAIL_HISTORY,
    callback,
    path: `/admin/email/history/getAll?offset=${offset}&limit=${limit}&sortType=createdAt`,
  };
}

export function changeHistoryFilter(name, value) {
  return {
    type: REQUEST_EMAIL_HISTORY_FILTER,
    name,
    value,
  };
}
